import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import MotivoResultadoService from '../../app/service/MotivoResultadoService'

class Motivo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      motivo: null,
      motivos: [],
      codigo: '',
      nome: '',
      modalMotivo: false,
      modalMotivoAlterar: false,
      openSpinner: false,
    }

    this.motivoResultadoService = new MotivoResultadoService();

    this.acoes = this.acoes.bind(this);
    this.accept = this.accept.bind(this);
    this.renderFooterCadastroMotivo = this.renderFooterCadastroMotivo.bind(this);
    this.renderFooterAlterarMotivo = this.renderFooterAlterarMotivo.bind(this);
  }

  listarMotivos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.motivoResultadoService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({motivos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Motivos de Resultado', detail:`${this.state.detail}`, life: 4000});
      })
  }

  abrirModalCadastro(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.limparCampos();
    this.setState(state);
  }

  limparCampos() {
    this.setState({motivo: null});
    this.setState({nome: ''});
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarMotivo(rowData)}
                tooltip="Editar Motivo" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Motivo" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  confirmaExclusao(motivo) {
    this.setState({codigo: motivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o Motivo do Resultado?',
        header: 'Exclusão de Motivo do Resultado',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  excluirMotivo() {
    this.setState({openSpinner: true});
    this.motivoResultadoService.excluir(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Motivos de Resultado', detail:'Motivo de Resultado excluído com sucesso', life: 4000});
        this.listarMotivos();
      });
      this.setState({openSpinner: false});
  }

  accept() {
    this.excluirMotivo();
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  renderFooterCadastroMotivo(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarMotivo}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterAlterarMotivo(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarMotivo}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  async consultarMotivo(motivo){
    this.setState({openSpinner: true});
    this.motivoResultadoService.consultar(motivo.codigo)
      .then(response => {
        this.setState({motivo: response.data});
        this.setState({nome: response.data.nome});
        this.setState({codigo: response.data.codigo});
        this.abrirModaAlterar('modalMotivoAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Motivos de Resultado', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  cadastrarMotivo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Motivo de Resultado', detail:'Nome do Motivo de Resultado é obrigatório', life: 4000});
      return;
    }
    const motivo = {
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    this.motivoResultadoService.cadastrar(motivo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Motivo de Resultado', detail:'Motivo de Resultado cadastrado com sucesso', life: 4000});
        this.fecharModal('modalMotivo');
        this.listarMotivos();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Motivo de Resultado', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  alterarMotivo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Motivo de Resultado', detail:'Nome do Motivo de Resultado é obrigatório', life: 4000});
      return;
    }

    const motivo = {
      codigo: this.state.codigo,
      nome: this.state.nome,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    this.motivoResultadoService.alterar(motivo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Motivo de Resultado', detail:'Motivo de Resultado alterado com sucesso', life: 4000});
        this.fecharModal('modalMotivoAlterar');
        this.listarMotivos();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Motivo de Resultado', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarMotivos();
    this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          {/**Cadastro de Motivos */}
          <Dialog header="Cadastro de Motivo de Resultado"
                    visible={this.state.modalMotivo} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroMotivo('modalMotivo')} 
                    onHide={() => this.fecharModal('modalMotivo')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeMotivo">Nome</label>
                        <InputText id="nomeMotivo" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Alterar Motivos */}
          <Dialog header="Alterar Motivo de Resultado"
                    visible={this.state.modalMotivoAlterar} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarMotivo('modalMotivoAlterar')} 
                    onHide={() => this.fecharModal('modalMotivoAlterar')}>
                
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeMotivoAlterar">Nome</label>
                        <InputText id="nomeMotivoAlterar" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="pi pi-wallet"></i>
                        <span> Motivos de Resultado</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={() => this.abrirModalCadastro('modalMotivo')}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="fas fa-plus"></i> Adicionar</button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.motivos}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage=" " rows={10}>
                      <Column field="nome" header="Nome"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

Motivo.contextType = AuthContext;
export default withRouter (Motivo)